import '../bootstrap';
import { initPublicHeader } from './header';

import intlTelInput from 'intl-tel-input';
window.intlTelInput = intlTelInput;

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';
window.AirDatepicker = AirDatepicker;
window.localeEn = localeEn;

import select2 from 'select2';
import 'select2/dist/css/select2.css';
select2($);

window.Swal = {
    _lib: null,
    async fire(...args) {
        if (!this._lib) {
            await import('sweetalert2/src/sweetalert2.scss');
            this._lib = (await import('sweetalert2/dist/sweetalert2.js')).default;
        }

        return this._lib.fire(...args);
    },
};

if (document.querySelector('[data-aos]')) {
    (async () => {
        await import('aos/dist/aos.css');
        const AOS = (await import('aos')).default;

        AOS.init();
        window.addEventListener('load', AOS.refresh);
    })();
}

document.addEventListener('DOMContentLoaded', function () {
    const config = window.ReservationPage || {};

    initPublicHeader();
    showSuccessModal(config);
    initRecaptcha(config);
    initReservationForm(config);

    if (!config.disableBookingService) {
        initServicePicker(config);
    }
});

function showSuccessModal(config) {
    if (!config.hasSuccess) return;

    if (typeof fbq === 'function') {
        fbq('track', 'CompleteRegistration');
    }

    Swal.fire({
        title: config.successModal.title,
        html: config.successModal.html,
        icon: 'success',
        confirmButtonText: config.successModal.confirmButtonText,
        confirmButtonColor: config.successModal.confirmButtonColor,
    });
}

function initRecaptcha(config) {
    if (!config.recaptcha?.enabled || typeof grecaptcha === 'undefined') return;

    grecaptcha.ready(function () {
        grecaptcha.execute(config.recaptcha.sitekey, { action: config.recaptcha.action })
            .then(function (token) {
                const tokenInput = document.getElementById('recaptcha_v3_token');

                if (tokenInput) {
                    tokenInput.value = token;
                }
            });
    });
}

function initReservationForm(config) {
    const bookingConfig = config.booking;

    const clearInvalid = (element) => {
        if (!element) return;

        element.classList.remove('is-invalid');
        element.closest('.input-group')?.classList.remove('is-invalid');
    };

    $('#branch_id').select2({
        templateResult: formatBranchOption,
        templateSelection: formatBranchSelection,
        escapeMarkup: function (m) { return m; },
        minimumResultsForSearch: -1,
        dropdownCssClass: 'branch-select-dropdown',
        width: 'resolve',
    });

    $('#branch_id').on('change', function () {
        if ($(this).val()) {
            $(this).removeClass('is-invalid');
        }

        resetAvailabilityStateForBranchChange();
        refreshCalendarAvailability(true);
        refreshGuestPicker();
        updateCustomerPhoneCountry();
        toggleNotesIfBranchHasAdvanceThreeDays();
    });

    function formatBranchOption(branch) {
        if (!branch.id) {
            return branch.children ? `<span class="d-block fw-bold px-3 pt-2 pb-2">${branch.text}</span>` : null;
        }

        const address = branch.element.getAttribute('data-address');
        const phone = branch.element.getAttribute('data-phone');

        return $(`
            <div class="branch-option">
                <span class="branch-name fw-bold">${branch.text}</span>
                ${address ? `<span class="branch-address fw-regular">${address}</span>` : ''}
                ${phone ? `<span class="branch-phone fw-regular">Tel: ${phone}</span>` : ''}
            </div>
        `);
    }

    function formatBranchSelection(branch) {
        if (!branch.id) {
            return branch.text;
        }

        return $(`
            <div class="selected-branch">
                <span class="branch-name">${branch.text}</span>
            </div>
        `);
    }

    const DISABLED_BY_DATE = bookingConfig.disabledByDate;
    const DEFAULT_BOOKING_AVAILABILITY = bookingConfig.defaultAvailability;
    const BOOKING_AVAILABILITY = bookingConfig.availability;
    const BRANCH_BOOKING_START_DATES = bookingConfig.branchStartDates;
    const BRANCH_BLOCKED_DATES = bookingConfig.branchBlockedDates;
    const BRANCH_DATE_OVERRIDES = bookingConfig.branchDateOverrides;
    const BOOKED_PAX_BY_TIMESLOT = bookingConfig.bookedPaxByTimeslot;
    const BRANCH_PAX_CAPACITIES = bookingConfig.branchPaxCapacities;
    const PHONE_COUNTRY_OPTIONS = bookingConfig.phoneCountryOptions || [];
    const GUEST_LIMIT_NOTE = bookingConfig.guestLimitNote;
    const MASE_AVAILABLE_TIMES_URL = bookingConfig.maseAvailableTimesUrl;
    const MASE_COUNTRIES = bookingConfig.maseCountries || [];
    const MASE_ENABLED_BRANCH_IDS = (bookingConfig.maseEnabledBranchIds || []).map(String);
    const translatedOrFallback = (value, fallback) => value && !String(value).startsWith('reservation.')
        ? value
        : fallback;
    const LOADING_SLOTS_TEXT = translatedOrFallback(config.translations.loadingSlots, 'Checking available times...');
    const NO_SLOTS_TEXT = translatedOrFallback(config.translations.noSlotsAvailable, 'No available times for this date.');
    const CONFIRMING_BOOKING_TEXT = translatedOrFallback(config.translations.confirmingBooking, 'Confirming...');

    let slots = Array.from(document.querySelectorAll('.timeslot'));
    let maseAvailabilityRequest = 0;
    // Cache successful slot lookups and share in-flight ones so rapid date/service changes do not duplicate the same API call.
    const maseAvailabilityCache = new Map();
    const maseAvailabilityRequests = new Map();
    let maseAvailabilityAbortController = null;
    let queuedTimeslotRender = null;
    let queuedTimeslotRenderTimer = null;
    let isSubmitting = false;

    const branch_select = document.getElementById('branch_id');
    const booking_time = document.getElementById('booking_time');
    const party_size = document.getElementById('party_size');
    const timeslots_element = document.querySelector('.timeslots');
    const booking_date = document.getElementById('booking_date');
    const booking_calendar = document.getElementById('booking_calendar');
    // MaSe hidden slot fields are intentionally disabled for now.
    // Submit rechecks MaSe server-side, so the browser only needs to post booking_date/booking_time/service_ids.

    const first_available_date = bookingConfig.firstAvailableDate;

    const customer_phone_input = document.getElementById('customer_phone');
    const customer_phone_group = document.getElementById('customer_phone_group');
    const customer_phone_prefix = document.getElementById('inputGroupCustomerPhone');
    const country_code_input = document.getElementById('country_code');
    const country_name_input = document.getElementById('country_name');
    const reservation_form = document.getElementById('reservation_form');
    const submit_button = reservation_form?.querySelector('button[type="submit"]');

    const TODAY = bookingConfig.today;
    const CURRENT_TIME = bookingConfig.currentTime;

    let customerPhoneIti = null;
    let oldPhoneCountry = null;

    function getCountryIsoByDialCode(dial_code) {
        if (!dial_code || !window.intlTelInput?.getCountryData) return null;

        const clean_dial_code = String(dial_code).replace(/\D/g, '');
        const country = window.intlTelInput.getCountryData()
            .find((country) => country.dialCode === clean_dial_code);

        return country?.iso2 || null;
    }

    function enableInternationalPhoneInput(country_code) {
        if (!customer_phone_input || !window.intlTelInput) return;

        customer_phone_prefix.classList.add('d-none');
        customer_phone_group.classList.remove('input-group');
        oldPhoneCountry ??= getCountryIsoByDialCode(country_code_input.value);

        const initial_country = oldPhoneCountry || country_code || 'sg';
        oldPhoneCountry = null;

        if (!customerPhoneIti) {
            customerPhoneIti = window.intlTelInput(customer_phone_input, {
                separateDialCode: true,
                initialCountry: initial_country,
                countryOrder: PHONE_COUNTRY_OPTIONS,
                countrySearch: false,
            });
        } else {
            customerPhoneIti.setCountry(initial_country);
        }
    }

    function disableInternationalPhoneInput() {
        if (customerPhoneIti) {
            customerPhoneIti.destroy();
            customerPhoneIti = null;
        }

        customer_phone_prefix.classList.remove('d-none');
        customer_phone_group.classList.add('input-group');
        country_code_input.value = '';
        country_name_input.value = '';
    }

    function selectedBranchUsesInternationalPhone() {
        const selected_option = branch_select.options[branch_select.selectedIndex];

        return selected_option?.dataset.useInternationalPhone === '1';
    }

    function selectedBranchCountryCode() {
        const selected_option = branch_select.options[branch_select.selectedIndex];

        return (selected_option?.dataset.countryCode || '').toLowerCase();
    }

    const shouldUseMaseAvailability = () => hasSelectedBranch()
        && MASE_AVAILABLE_TIMES_URL
        && MASE_COUNTRIES.includes(selectedBranchCountryCode())
        && MASE_ENABLED_BRANCH_IDS.includes(String(branch_select.value));

    function updateCustomerPhoneCountry() {
        const selected_option = branch_select.options[branch_select.selectedIndex];

        if (!selected_option || !selected_option.value) {
            disableInternationalPhoneInput();
            return;
        }

        const country_code = selected_option.dataset.countryCode;
        const phone_code = selected_option.dataset.phoneCode;

        if (!country_code || !phone_code) return;

        if (selectedBranchUsesInternationalPhone()) {
            enableInternationalPhoneInput(country_code);
            return;
        }

        disableInternationalPhoneInput();

        const flag_url = selected_option.dataset.flagUrl;
        const customer_phone_flag = document.getElementById('customer_phone_flag');

        if (flag_url) {
            customer_phone_flag.src = flag_url;
        }

        customer_phone_flag.alt = country_code.toUpperCase();
        document.getElementById('customer_phone_code').textContent = phone_code;
    }

    function toggleNotesIfBranchHasAdvanceThreeDays() {
        const selected_option = branch_select.options[branch_select.selectedIndex];
        const branch_booking_availability = selected_option.dataset.bookingAvailability;
        if( branch_booking_availability ){
            const advance_three_days_note = document.getElementById('advance_three_days_note');
            const uses_booking_availability = branch_booking_availability <= 1;
            advance_three_days_note.classList.toggle('d-none', uses_booking_availability);
        }
    }

    // The placeholder has an empty value. Only a real numeric branch ID should switch the calendar from default hours to branch rules.
    const hasSelectedBranch = () => /^\d+$/.test(branch_select.value);
    const getSelectedBranchCapacity = () => hasSelectedBranch()
        ? Number(BRANCH_PAX_CAPACITIES[branch_select.value] ?? 0)
        : 0;
    const getBookedPax = (date_str, time) => Number(
        BOOKED_PAX_BY_TIMESLOT[branch_select.value]?.[date_str]?.[time] ?? 0
    );
    const getRemainingPax = (date_str, time) => Math.max(
        0,
        getSelectedBranchCapacity() - getBookedPax(date_str, time)
    );

    // Before branch selection, preserve the original all-week default hours.
    // After selection, use only that branch's configured open days and slots.
    const getSelectedBranchAvailability = () => hasSelectedBranch()
        ? (BOOKING_AVAILABILITY[branch_select.value] ?? {})
        : DEFAULT_BOOKING_AVAILABILITY;
    // A branch can push the booking start later than the regional default.
    // Null branch dates fall back to first_available_date from the controller.
    const getSelectedBranchStartDate = () => hasSelectedBranch()
        ? (BRANCH_BOOKING_START_DATES[branch_select.value] ?? first_available_date)
        : first_available_date;
    const isSelectedBranchBlockedDate = (date_str) => hasSelectedBranch()
        ? (BRANCH_BLOCKED_DATES[branch_select.value] ?? []).includes(date_str)
        : false;
    const getSelectedBranchDateOverride = (date_str) => hasSelectedBranch()
        ? (BRANCH_DATE_OVERRIDES[branch_select.value]?.[date_str] ?? null)
        : null;
    const getDayAvailability = (date_str) => {
        const date = new Date(`${date_str}T00:00:00`);
        const date_override = getSelectedBranchDateOverride(date_str);

        if (date_override) {
            return date_override;
        }

        return getSelectedBranchAvailability()[date.getDay()] ?? null;
    };

    const formatDate = (date) => [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
    ].join('-');
    // Keep date parsing local. Plain YYYY-MM-DD can be read as UTC by browsers and shift the date in some timezones.
    const parseDate = (date_str) => new Date(`${date_str}T00:00:00`);

    const isPastSlot = (date_str, time) => date_str === TODAY && time <= CURRENT_TIME;

    function renderTimeslotMessage(message, class_name = '') {
        timeslots_element.innerHTML = '';
        slots = [];

        const message_element = document.createElement('div');

        message_element.className = ['timeslot-message', class_name].filter(Boolean).join(' ');
        message_element.textContent = message;
        timeslots_element.appendChild(message_element);
    }

    function setTimeslotsLoading(is_loading) {
        timeslots_element.classList.toggle('is-loading', is_loading);
        timeslots_element.setAttribute('aria-busy', is_loading ? 'true' : 'false');
        if (is_loading) {
            // Clear the hidden time while MaSe is still checking so a stale selected slot cannot be submitted.
            booking_time.value = '';
            setMaseSlotInputs(null);
            renderTimeslotMessage(LOADING_SLOTS_TEXT, 'timeslot-loading');
        }
    }

    function setMaseSlotInputs(slot) {
        // Kept as a no-op while the old hidden-field submit flow is commented out.
        // The selected slot is resolved again in PublicController before MaSe create.
    }

    const isDateAvailable = (date) => {
        // Block all dates before the selected branch's effective start date,
        // even if the weekday itself has available slots.
        const date_str = formatDate(date);

        if (date_str < getSelectedBranchStartDate()) return false;
        if (isSelectedBranchBlockedDate(date_str)) return false;

        const day_availability = getDayAvailability(date_str);

        return Boolean((day_availability?.slots ?? []).length);
    };

    // AirDatepicker initial load works because minDate and selectedDates are created together. 
    // Do the same on branch changes, then move the visible month with setViewDate so a future branch start does not leave today highlighted.
    const selectCalendarDate = (date_str, min_date = date_str) => {
        const selected_date = parseDate(date_str);

        booking_date.value = date_str;
        dp.update({
            minDate: parseDate(min_date),
            selectedDates: [selected_date],
        }, { silent: true });
        dp.setViewDate(selected_date);
        renderTimeslots(date_str);
    };

    const findFirstAvailableDate = () => {
        const date = parseDate(getSelectedBranchStartDate());

        // A branch may be closed on its start date, so move forward until the next configured open weekday is found.
        for (let day = 0; day < 366; day++) {
            if (isDateAvailable(date)) return formatDate(date);

            date.setDate(date.getDate() + 1);
        }

        return null;
    };

    function maseAvailabilityKey(date_str) {
        return new URLSearchParams({
            branch_id: branch_select.value,
            booking_date: date_str,
            party_size: party_size.value || '1',
            service_ids: document.getElementById('service_ids')?.value || '[]',
        }).toString();
    }

    async function getMaseAvailableSlots(date_str) {
        // Date/service/guest changes can trigger overlapping requests; only the newest response should update the UI.
        const request_id = ++maseAvailabilityRequest;
        const params = maseAvailabilityKey(date_str);

        if (maseAvailabilityCache.has(params)) {
            return maseAvailabilityCache.get(params);
        }

        if (!maseAvailabilityRequests.has(params)) {
            // Abort older, different lookups; their results are no longer useful once the user changed date/service/guest count.
            maseAvailabilityAbortController?.abort();
            maseAvailabilityAbortController = new AbortController();

            const request = fetch(`${MASE_AVAILABLE_TIMES_URL}?${params}`, {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                signal: maseAvailabilityAbortController.signal,
            })
                .then(response => response.json())
                .then(payload => {
                    const times = payload.success ? (payload.times || []) : [];

                    maseAvailabilityCache.set(params, times);

                    return times;
                })
                .finally(() => {
                    maseAvailabilityRequests.delete(params);
                });

            maseAvailabilityRequests.set(params, request);
        }

        try {
            const times = await maseAvailabilityRequests.get(params);

            if (request_id !== maseAvailabilityRequest) {
                // Another availability request finished later and owns the UI now.
                return null;
            }

            return times;
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.warn('Unable to fetch MaSe available times.', error);
            }

            return request_id === maseAvailabilityRequest ? [] : null;
        }
    }

    async function renderTimeslots(date_str) {
        const render_branch_id = branch_select.value;
        const day_availability = getDayAvailability(date_str);
        const use_mase_availability = shouldUseMaseAvailability();
        const prev = booking_time.value;

        if (use_mase_availability) {
            setTimeslotsLoading(true);
        }

        // Malaysia renders the full local working-hour list, then overlays MaSe availability below.
        // This keeps past/unavailable hours visible and disabled instead of making them disappear.
        const local_slots = day_availability?.slots ?? [];
        const mase_slots = use_mase_availability
            ? await getMaseAvailableSlots(date_str)
            : null;

        if (branch_select.value !== render_branch_id || booking_date.value !== date_str) {
            return;
        }

        if (use_mase_availability && mase_slots === null) {
            return;
        }

        setTimeslotsLoading(false);

        const legacy_disabled_times = DISABLED_BY_DATE[branch_select.value]?.[date_str] ?? [];
        const capacity = getSelectedBranchCapacity();
        // Key MaSe results by time so we can keep every local working-hour button
        // and only change its count/disabled state when MaSe has matching availability.
        const mase_slots_by_time = new Map((mase_slots || []).map(slot => [slot.value, slot]));

        timeslots_element.innerHTML = '';
        slots = local_slots.map(local_slot => {
            // Always build the button from the local branch schedule first.
            // MaSe data only decides the count/disabled state, so dashboard hours like 7-9pm still appear greyed out.
            const slot_data = use_mase_availability
                ? (mase_slots_by_time.get(local_slot.value) || local_slot)
                : local_slot;
            const slot = document.createElement('div');
            const remaining = use_mase_availability
                ? null
                : capacity > 0
                ? getRemainingPax(date_str, local_slot.value)
                : null;
            const mase_available_count = use_mase_availability && mase_slots_by_time.has(local_slot.value)
                ? Number(slot_data.available_slots ?? 0)
                : 0;

            slot.className = 'timeslot';
            slot.dataset.value = local_slot.value;
            // For MaSe branches, zero means MaSe did not return this working-hour slot.
            // We still render it below so the UI can grey it out instead of hiding it.
            const available_count = use_mase_availability
                ? mase_available_count
                : remaining;

            slot.textContent = available_count === null ? local_slot.label : `${local_slot.label} (${available_count})`;
            slot.dataset.remaining = available_count ?? '';

            if (prev === local_slot.value) {
                slot.classList.add('active');
            }

            slot.addEventListener('click', (e) => {
                setActive(e.currentTarget, slots, booking_time, timeslots_element);
                setMaseSlotInputs(use_mase_availability ? e.currentTarget : null);
            });
            timeslots_element.appendChild(slot);

            return slot;
        });

        if (slots.length === 0) {
            renderTimeslotMessage(NO_SLOTS_TEXT);
        }

        slots.forEach(slot => {
            const time = slot.dataset.value || slot.getAttribute('data-value');
            // MaSe mode disables anything not returned by MaSe, but keeps the branch's full day visible.
            const is_disabled = use_mase_availability
                ? isPastSlot(date_str, time) || !mase_slots_by_time.has(time) || Number(slot.dataset.remaining) <= 0
                : capacity > 0
                ? isPastSlot(date_str, time) || Number(slot.dataset.remaining) <= 0
                : isPastSlot(date_str, time) || legacy_disabled_times.includes(time);

            slot.classList.toggle('disabled', is_disabled);

            if (is_disabled) {
                slot.classList.remove('active');
            }
        });

        // re-select previous if possible
        const previous_has_capacity = use_mase_availability
            ? mase_slots_by_time.has(prev)
            : capacity > 0
            ? !isPastSlot(date_str, prev) && getRemainingPax(date_str, prev) >= Number(party_size.value || 1)
            : !isPastSlot(date_str, prev) && !legacy_disabled_times.includes(prev);

        booking_time.value = prev && local_slots.some(slot => slot.value === prev) && previous_has_capacity
            ? prev
            : '';

        if (booking_time.value && use_mase_availability) {
            setMaseSlotInputs(slots.find(slot => slot.dataset.value === booking_time.value) || null);
        } else {
            setMaseSlotInputs(null);
        }
    }

    function queueTimeslotRender(date_str) {
        // Several controls can fire during the same UI change, especially Select2 during service setup.
        // Queue one render per tick so identical date/service/guest state only makes one availability request.
        queuedTimeslotRender = date_str;
        clearTimeout(queuedTimeslotRenderTimer);
        queuedTimeslotRenderTimer = setTimeout(() => {
            renderTimeslots(queuedTimeslotRender);
            queuedTimeslotRender = null;
        }, 80);
    }

    function resetAvailabilityStateForBranchChange() {
        booking_time.value = '';
        setMaseSlotInputs(null);
        maseAvailabilityRequest += 1;
        maseAvailabilityAbortController?.abort();
        maseAvailabilityAbortController = null;
        maseAvailabilityCache.clear();
        maseAvailabilityRequests.clear();
        clearTimeout(queuedTimeslotRenderTimer);
        queuedTimeslotRender = null;
    }

    function refreshCalendarAvailability(reset_to_branch_start = false) {
        if (!hasSelectedBranch()) {
            const next_available_date = findFirstAvailableDate();
            // Initial state matches the legacy form: preselect the regional minimum date and show the default times immediately.
            selectCalendarDate(next_available_date || first_available_date, first_available_date);
            return;
        }

        const branch_start_date = getSelectedBranchStartDate();

        // When the selected branch starts later than the regional default, force the selected date to the branch's first valid booking day.
        // On branch change, always reset from that branch's own start date; otherwise a previously selected future date can carry over.
        if (reset_to_branch_start || (booking_date.value && !isDateAvailable(parseDate(booking_date.value)))) {
            const next_available_date = findFirstAvailableDate();

            if (next_available_date) {
                selectCalendarDate(next_available_date, branch_start_date);
            } else {
                // No configured open day was found in the next year. Keep the calendar on the branch start month but leave the form date empty.
                dp.update({ minDate: parseDate(branch_start_date), selectedDates: [] }, { silent: true });
                dp.setViewDate(parseDate(branch_start_date));
                booking_date.value = '';
                booking_time.value = '';
                timeslots_element.innerHTML = '';
            }
        } else if (booking_date.value) {
            renderTimeslots(booking_date.value);
        } else {
            booking_time.value = '';
            timeslots_element.innerHTML = '';
        }
    }

    const dp = new AirDatepicker('#booking_calendar', {
        inline: true,
        locale: localeEn,
        dateFormat: 'yyyy-MM-dd',
        minDate: first_available_date,
        selectedDates: booking_date.value ? [booking_date.value] : false,
        onRenderCell({ date, cellType }) {
            if (cellType !== 'day') return;

            return {
                // Do not restrict weekdays until the customer chooses a branch.
                disabled: !isDateAvailable(date),
            };
        },
        onSelect({ formattedDate }) {
            booking_date.value = formattedDate;
            if (formattedDate) {
                renderTimeslots(formattedDate);
            }
            clearInvalid(booking_calendar);
        },
    });

    const numbers = Array.from(document.querySelectorAll('.number-guest'));
    const ngw_element = document.querySelector('.number-guest-wrap');
    const legacy_guest_picker = document.getElementById('legacy_guest_picker');
    const capacity_guest_picker = document.getElementById('capacity_guest_picker');
    const party_size_display = document.getElementById('party_size_display');
    const decrease_party_size = document.getElementById('decrease_party_size');
    const increase_party_size = document.getElementById('increase_party_size');
    const guest_limit_note = document.getElementById('guest_limit_note');

    const selectedSlotRemaining = () => {
        if (!booking_date.value || !booking_time.value || getSelectedBranchCapacity() <= 0) return null;
        return getRemainingPax(booking_date.value, booking_time.value);
    };

    const refreshGuestPicker = () => {
        const capacity = getSelectedBranchCapacity();
        const uses_capacity = capacity > 0;

        legacy_guest_picker.classList.toggle('d-none', uses_capacity);
        capacity_guest_picker.classList.toggle('d-none', !uses_capacity);
        guest_limit_note.textContent = GUEST_LIMIT_NOTE.replace(':count', uses_capacity ? capacity : 3);

        if (uses_capacity) {
            // After slot selection, limit the stepper by that slot's remaining pax instead of branch capacity.
            const slot_remaining = selectedSlotRemaining();
            const maximum = slot_remaining === null ? capacity : Math.min(capacity, slot_remaining);
            const value = Math.max(1, Math.min(Number(party_size.value || party_size_display.value || 1), maximum || 1));
            party_size.value = value;
            party_size_display.value = value;
            decrease_party_size.disabled = value <= 1;
            increase_party_size.disabled = maximum <= 0 || value >= maximum;
        } else {
            // Prevent a larger capacity-mode value from leaking into the legacy 1-3 guest controls.
            const value = Math.max(1, Math.min(Number(party_size.value || 1), 3));
            party_size.value = value;
            numbers.forEach(number => number.classList.toggle('active', Number(number.dataset.value) === value));
        }
    };

    const setActive = (el, elements, target_element, clear_element) => {
        // clear all, set one
        elements.forEach(s => s.classList.remove('active'));
        if (!el.classList.contains('disabled')) {
            el.classList.add('active');
            // Only enabled choices may update the submitted value.
            const t = el.dataset.value || el.getAttribute('data-value');
            if (t) target_element.value = t;
        }

        clearInvalid(clear_element);
    };

    slots.forEach(slot => {
        slot.addEventListener('click', (e) => setActive(e.currentTarget, slots, booking_time, timeslots_element));
    });

    refreshCalendarAvailability();
    updateCustomerPhoneCountry();
    toggleNotesIfBranchHasAdvanceThreeDays();

    numbers.forEach(number => {
        number.addEventListener('click', (e) => {
            setActive(e.currentTarget, numbers, party_size, ngw_element);
            if (booking_date.value && shouldUseMaseAvailability()) queueTimeslotRender(booking_date.value);
        });
    });

    decrease_party_size.addEventListener('click', () => {
        party_size.value = Math.max(1, Number(party_size.value || 1) - 1);
        refreshGuestPicker();
        if (booking_date.value && shouldUseMaseAvailability()) queueTimeslotRender(booking_date.value);
    });

    increase_party_size.addEventListener('click', () => {
        party_size.value = Number(party_size.value || 1) + 1;
        refreshGuestPicker();
        if (booking_date.value && shouldUseMaseAvailability()) queueTimeslotRender(booking_date.value);
    });

    timeslots_element.addEventListener('click', (event) => {
        if (event.target.closest('.timeslot')) refreshGuestPicker();
    });

    document.addEventListener('reservation:services-changed', () => {
        if (booking_date.value) queueTimeslotRender(booking_date.value);
    });

    customer_phone_input?.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        this.classList.remove('is-invalid');
        customer_phone_group?.classList.remove('is-invalid');

        const feedback = customer_phone_group?.parentElement?.querySelector('.invalid-feedback');

        feedback?.remove();
    });

    reservation_form?.addEventListener('submit', function (event) {
        if (isSubmitting) {
            event.preventDefault();
            return;
        }

        // Server-side validation still protects the booking, but this prevents accidental double-click creates.
        isSubmitting = true;
        if (submit_button) {
            submit_button.disabled = true;
            submit_button.dataset.originalText = submit_button.textContent;
            submit_button.textContent = CONFIRMING_BOOKING_TEXT;
            submit_button.classList.add('is-loading');
        }

        if (selectedBranchUsesInternationalPhone() && customerPhoneIti) {
            const selected_country = customerPhoneIti.getSelectedCountryData();

            country_code_input.value = selected_country.dialCode ? `+${selected_country.dialCode}` : '';
            country_name_input.value = selected_country.name || '';
            return;
        }

        country_code_input.value = '';
        country_name_input.value = '';
    });

    const closeCustomerPhoneDropdown = () => {
        const opened_dropdown = document.querySelector('.iti__dropdown-content:not(.iti__hide)');

        if (opened_dropdown) {
            document.body.click();
        }
    };

    window.addEventListener('resize', closeCustomerPhoneDropdown);
    window.addEventListener('orientationchange', closeCustomerPhoneDropdown);

    refreshGuestPicker();
}

function initServicePicker(config) {
    const add_btn = document.getElementById('add_another_service_btn');
    const original = document.getElementById('service');
    const target = document.getElementById('new_service_group');
    const service_ids_input = document.getElementById('service_ids');

    if (!original || !target || !service_ids_input) return;

    if (add_btn) add_btn.setAttribute('type', 'button');

    const parseOld = (val) => {
        if (!val) return [];

        try {
            const j = JSON.parse(val);

            return Array.isArray(j) ? j.map(String) : (j ? [String(j)] : []);
        } catch {
            return String(val).split(/[,\s]+/).map(s => s.trim()).filter(Boolean);
        }
    };

    const allSelects = () => $('.selection-service');
    const getAllSelects = () => Array.from(document.querySelectorAll('select.selection-service'));
    const getSelectedValues = () => getAllSelects().map(s => s.value).filter(v => v && v !== 'Choose service');

    const syncServices = () => {
        const next_value = JSON.stringify(getSelectedValues());

        if (service_ids_input.value === next_value) {
            return;
        }

        // Only notify the booking calendar when the real service IDs changed.
        // Select2 can fire setup/change events that should not refetch the same MaSe availability.
        service_ids_input.value = next_value;
        document.dispatchEvent(new CustomEvent('reservation:services-changed'));
    };

    const refreshDisabledOptions = () => {
        const chosen = new Set(getSelectedValues());

        allSelects().each(function () {
            const sel = $(this);
            const self_val = sel.val();

            sel.find('option').each(function () {
                const opt = $(this);
                const val = opt.attr('value');

                if (!val) return;

                opt.prop('disabled', chosen.has(val) && val !== self_val);
            });
        });
    };

    const templateHTML = (() => {
        const tmp = original.cloneNode(false);

        tmp.innerHTML = original.innerHTML;

        const first = tmp.options[0];

        if (!first || first.value !== '') {
            const ph = document.createElement('option');

            ph.value = '';
            tmp.insertBefore(ph, tmp.firstChild);
        }

        return tmp.innerHTML;
    })();

    const initSelect2 = (sel) => {
        $(sel).select2({
            minimumResultsForSearch: -1,
            placeholder: $(sel).data('placeholder'),
            width: '100%',
            dropdownParent: $('body'),
        }).on('change.select2', () => {
            syncServices();
            refreshDisabledOptions();
        });
    };

    const makeClone = (selected_value = '') => {
        const count = target.querySelectorAll('select[name^="service_"]').length;
        const next = count + 1;

        const clone = document.createElement('select');

        clone.className = 'form-select fw-light selection-service';
        clone.id = `service_${next}`;
        clone.name = `service_${next}`;
        clone.setAttribute('data-placeholder', config.translations.chooseServicePlaceholder);
        clone.innerHTML = templateHTML;
        clone.value = selected_value ? String(selected_value) : '';

        const wrap = document.createElement('div');

        wrap.className = 'mt-2';
        wrap.appendChild(clone);
        target.appendChild(wrap);

        initSelect2(clone);

        return clone;
    };

    initSelect2(original);

    const initial = parseOld(service_ids_input.value);

    if (initial.length) {
        $(original).val(String(initial[0])).trigger('change.select2');
    } else {
        $(original).val('').trigger('change.select2');
    }

    if (initial.length > 1) {
        initial.slice(1).forEach(val => makeClone(val));
    }

    syncServices();
    refreshDisabledOptions();

    if (add_btn) {
        add_btn.addEventListener('click', (e) => {
            e.preventDefault();
            makeClone('');
            refreshDisabledOptions();
        });
    }

    const clearInvalid = (el) => {
        if (!el) return;

        el.classList.remove('is-invalid');

        const parent_input_group = el.closest('.input-group');

        if (parent_input_group) {
            parent_input_group.classList.remove('is-invalid');
        }
    };

    document.addEventListener('input', (e) => {
        const t = e.target;

        if (t.matches('input, textarea, select')) clearInvalid(t);
    }, true);

    document.addEventListener('change', (e) => {
        const t = e.target;

        if (t.matches('input, textarea, select')) clearInvalid(t);
    }, true);
}
